import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props { children: ReactNode }
interface State { hasError: boolean }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("UI_ERROR_BOUNDARY", { name: error.name, componentStack: info.componentStack?.slice(0, 400) });
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;
    return (
      <main className="error-screen">
        <div className="error-mark" aria-hidden="true">↺</div>
        <p className="eyebrow">SOUTH LAKE / RETRY</p>
        <h1>南湖起了一阵风。</h1>
        <p>这页没有准备好，但你的答案仍然可以重新开始。</p>
        <button className="button button-primary" type="button" onClick={() => window.location.reload()}>重新进入</button>
      </main>
    );
  }
}
